import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { GetMedicineRequest } from '../../requests/pharmacy/get-medicine.request';
import { GetListKitResponse } from '../../responses/pharmacy/get-list-kit.response';

@Injectable({
  providedIn: 'root'
})
export class MedicineLinkedKitService extends CommonService {

  constructor(private httpClient: HttpClient) { super(); }

  public getWithItemsByIdMedicine(getMedicineRequest: GetMedicineRequest): Observable<GetListKitResponse> {
    let uri = 'MedicineLinkedKit'

    return this.httpClient.post<GetListKitResponse>(environment.urlApiPharmacy + uri, getMedicineRequest, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
